var _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228,
    height: 40,
    viewBox: "0 0 228 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1720",
    style: {
      fill: "#203662"
    },
    d: "M0 0h228v40H0z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(114 25)",
    style: {
      fill: "#fff",
      font: "normal normal normal 10px/18px Nunito Sans",
      letterSpacing: 0
    },
    textAnchor: "middle"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Click Here"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/Button.c8092f1b82940d37d3b909df77366652.svg";
export { ForwardRef as ReactComponent };